import { seconds } from '@utils/milliseconds';

/** A refetch sooner than this reads the pre-write index and marks it fresh. */
export const ELASTICSEARCH_REINDEX_DELAY_MS = seconds(2);
